import { ApiService } from "../../services/api.service";
import Cookies from "universal-cookie";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import PageLoading from "../PageLoading/PageLoading";
import { useOutletContext } from "../../OutletContext";
import { adminPermissionsType, dashboardDataType } from "../../types";

import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Swal from "sweetalert2";

const Main = () => {
    const cookies = new Cookies(null, {path: '/'});
    const [loading, setLoading] = useState<boolean>(false);

    const context = useOutletContext();
    const [dashboardData, setDashboardData] = useState<dashboardDataType | null>(null)
    const [permissions, setPermissions] = useState<adminPermissionsType>({member: false, deposit_scb: false, promotion: false, create_admin: false, withdraw_transactions: false, report_all: false, report_all_data: false, report_click: false, settings: false, deposit_transactions: false, managelotto: false, manange_bank_account: false});
    const [showKey, setShowKey] = useState<boolean>(false);
    const [whitelistIpText, setWhitelistIpText] = useState<string>("");

    const whitelistIpRef = useRef<HTMLInputElement>(null);
    const callbackPayinRef = useRef<HTMLInputElement>(null);
    const callbackPayoutRef = useRef<HTMLInputElement>(null);
    const otpMerchantRef = useRef<HTMLInputElement>(null);
    const otpWhitelistRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const tmp_permissions: adminPermissionsType | null = context;
        if(tmp_permissions)
        {
            setPermissions(tmp_permissions);
        }
    }, []);

    useEffect(() => {
        getDashboard();
    }, [])

    const getDashboard = async () => {
        if(loading)
        {
            return;
        }

        setLoading(true);
        try {
            const service = new ApiService();
            const getDashboardData = await service.getDashboard(cookies.get('access_token'));

            if(getDashboardData.data.status_code === 200)
            {
                let whitelist_ip_text = "";
                let index = 0;
                for(const element of getDashboardData.data.information.whitelist_ip)
                {
                    if(index === 0)
                    {
                        whitelist_ip_text = `${element}`
                    }
                    else
                    {
                        whitelist_ip_text = `${whitelist_ip_text},${element}`
                    }

                    index++;
                }
                
                setWhitelistIpText(whitelist_ip_text);
                setDashboardData(getDashboardData.data.information);
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const resetMerchantKey = async () => {
        setLoading(true);
        try {
            if(!otpMerchantRef.current)
            {
                return;
            }

            const otp = otpMerchantRef.current.value;

            const service = new ApiService();
            const update = await service.resetMerchantKey(cookies.get('access_token'), otp.trim());

            const elementInput = document.getElementById("merchant_key_authenticator") as HTMLInputElement;
            if(elementInput)
            {
                elementInput.value = "";
            }

            if(update.data.status_code === 200)
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Notification',
                    text: 'Reset merchant key successfully'
                }).then((res) => {
                    if(res)
                    {
                        window.location.reload();
                    }
                });
            }
            else
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: `Reset merchant key failed (${update.data.status_code} - ${update.data.message})`
                });
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const updateWhitelistIp = async () => {
        setLoading(true);
        try {
            if(!whitelistIpRef.current || !otpWhitelistRef.current)
            {
                return;
            }

            const whitelistIp = whitelistIpRef.current.value;
            const otp = otpWhitelistRef.current.value;

            const service = new ApiService();
            const update = await service.updateWhitelistIp(cookies.get('access_token'), whitelistIp.trim(), otp.trim());

            const elementInput = document.getElementById("merchant_whitelist_ip_authenticator") as HTMLInputElement;
            if(elementInput)
            {
                elementInput.value = "";
            }

            if(update.data.status_code === 200)
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Notification',
                    text: 'Update whitelist ip successfully'
                });
            }
            else
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: `Update whitelist ip failed (${update.data.status_code} - ${update.data.message})`
                });
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const changeCallbackUrl = async () => {
        setLoading(true);
        try {
            if(!callbackPayinRef.current || !callbackPayoutRef.current)
            {
                return;
            }

            const callbackPayin = callbackPayinRef.current.value;
            const callbackPayout = callbackPayoutRef.current.value;

            const service = new ApiService();
            const update = await service.updateCallback(cookies.get('access_token'), callbackPayin.trim(), callbackPayout.trim());

            if(update.data.status_code === 200)
            {
                Swal.fire({
                    icon: 'success',
                    title: 'Notification',
                    text: 'Update callback successfully'
                });
            }
            else
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Notification',
                    text: `Update callback failed (${update.data.status_code} - ${update.data.message})`
                });
            }
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const togglePayin = async (e: ChangeEvent<HTMLInputElement>) => {
        if(!e.target || !dashboardData)
        {
            return;
        }

        try {
            setLoading(true);
            const service = new ApiService();
            await service.togglePayin(cookies.get('access_token'), dashboardData.disable_payin === 0 ? 1 : 0);
            setLoading(false);
            getDashboard();
        } catch (err) {
            console.log(err);
        }
    }

    const togglePayout = async (e: ChangeEvent<HTMLInputElement>) => {
        if(!e.target || !dashboardData)
        {
            return;
        }

        try {
            setLoading(true);
            const service = new ApiService();
            await service.togglePayout(cookies.get('access_token'), dashboardData.disable_payout === 0 ? 1 : 0);
            setLoading(false);
            getDashboard();
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            {
                <PageLoading loading={loading} />
            }
            {
                dashboardData ? <div className="row g-3 mb-3">
                    <div className="col-sm-6 col-xl-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="content-left">
                                        <span>BALANCE</span>
                                        <div className="d-flex align-items-end mt-2">
                                            <h4 className="mb-0 me-2">
                                                ฿{
                                                    parseFloat(String(dashboardData.balance)).toLocaleString('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="avatar">
                                        <span className="avatar-initial rounded bg-label-primary">
                                            <i className='bx bx-list-plus bx-sm'></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="content-left">
                                        <span>On hold</span>
                                        <div className="d-flex align-items-end mt-2">
                                            <h4 className="mb-0 me-2">
                                                ฿{
                                                    parseFloat(String(dashboardData.freeze_balance || 0)).toLocaleString('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="avatar">
                                        <span className="avatar-initial rounded bg-label-danger">
                                            <i className='bx bx-layer-minus bx-sm'></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="content-left">
                                        <span>Total deposits</span>
                                        <div className="d-flex align-items-end mt-2">
                                            <h4 className="mb-0 me-2">
                                                ฿{
                                                    parseFloat(String(dashboardData.total.payin_success_total || 0)).toLocaleString('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="avatar">
                                        <span className="avatar-initial rounded bg-label-success">
                                            <i className='bx bxs-plus-circle bx-sm' ></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div className="content-left">
                                        <span>Total withdraw</span>
                                        <div className="d-flex align-items-end mt-2">
                                            <h4 className="mb-0 me-2">
                                                ฿{
                                                    parseFloat(String(dashboardData.total.payout_success_total || 0)).toLocaleString('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })
                                                }
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="avatar">
                                        <span className="avatar-initial rounded bg-label-danger">
                                            <i className='bx bxs-minus-circle bx-sm'></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="row">
                            <div className="col-12 mb-2">
                                <div className="card">
                                    <div className="card-body">
                                        <Typography component={'h1'} display={`flex`} justifyContent={`center`} fontSize={28}>
                                            Account
                                        </Typography>
                                        <Typography component={'h1'} display={`flex`} justifyContent={`center`} fontSize={16}>
                                            Information
                                        </Typography>
                                        <Divider sx={{ mb: 1 }} />
                                        <Box display={`flex`} justifyContent={'space-evenly'}>
                                            <Box>
                                                <Typography align="center" fontSize={18}>
                                                    Payin fee
                                                </Typography>
                                                <Typography align="center">
                                                    {
                                                        parseFloat(`${dashboardData.payin_charge}`).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    } %
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Divider orientation="vertical" />
                                            </Box>
                                            <Box>
                                                <Typography align="center" fontSize={18}>
                                                    Payout fee
                                                </Typography>
                                                <Typography align="center">
                                                    {
                                                        parseFloat(`${dashboardData.payout_charge}`).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    } %
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider sx={{ my: .5 }} />
                                        <Typography align="center" fontSize={18}>
                                            Min - Max Payin
                                        </Typography>
                                        <Typography align="center">
                                            {
                                                parseFloat(`${dashboardData.min_payin}`).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })
                                            } - {
                                                parseFloat(`${dashboardData.max_payin}`).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })
                                            }
                                        </Typography>
                                        <Divider sx={{ my: .5 }} />
                                        <Typography align="center" fontSize={18}>
                                            Min - Max Payout
                                        </Typography>
                                        <Typography align="center">
                                            {
                                                parseFloat(`${dashboardData.min_payout}`).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })
                                            } - {
                                                parseFloat(`${dashboardData.max_payout}`).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })
                                            }
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <div className="card">
                                    <div className="card-body">
                                        <Typography component={'h1'} display={`flex`} justifyContent={`center`} fontSize={28}>
                                            Merchant settings
                                        </Typography>
                                        <Divider sx={{ mb: 1 }} />
                                        <Box display={`flex`} justifyContent={'space-evenly'}>
                                            <Box display={`flex`} justifyContent={`center`} alignContent={`center`} alignItems={`center`} gap={1}>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="toggle_switch_payin" defaultChecked={dashboardData.disable_payin == 0} checked={dashboardData.disable_payin == 0} onChange={togglePayin} />
                                                    <label className="form-check-label" htmlFor="toggle_switch_payin">
                                                        {
                                                            dashboardData.disable_payin == 0 ? "Enabled" : "Disabled"
                                                        } payin
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="toggle_switch_payout" defaultChecked={dashboardData.disable_payout == 0} checked={dashboardData.disable_payout == 0} onChange={togglePayout} />
                                                    <label className="form-check-label" htmlFor="toggle_switch_payout">
                                                        {
                                                            dashboardData.disable_payout == 0 ? "Enabled" : "Disabled"
                                                        } payout
                                                    </label>
                                                </div>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="merchant_api_key" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Merchant api key
                                    </label>
                                    <div className="input-group input-group-merge">
                                        <input type={showKey ? 'text' : 'password'} id="merchant_api_key" className="form-control"
                                            name="merchant_api_key" placeholder="Merchant api key"
                                            aria-describedby="merchant_api_key" value={dashboardData.key} readOnly={true} />
                                        <span className="input-group-text cursor-pointer" onClick={() => setShowKey(showKey ? false : true)}>
                                            <i className={`bx bx-${showKey ? 'show' : 'hide'}`} />
                                        </span>
                                    </div>
                                    <label htmlFor="merchant_key_authenticator" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Authenticator
                                    </label>
                                    <input type={'text'} id="merchant_key_authenticator" className="form-control"
                                        name="merchant_key_authenticator" placeholder="Authenticator" ref={otpMerchantRef} />
                                    <button className="btn btn-primary d-grid w-100 mt-1" type="button" onClick={resetMerchantKey}>Reset merchant key</button>
                                    <Divider sx={{ mt: 1 }} />
                                    <label htmlFor="merchant_whitelist_ip" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Whitelist ip
                                    </label>
                                    <input type={'text'} id="merchant_whitelist_ip" className="form-control"
                                        name="merchant_whitelist_ip" placeholder="Whitelist ip"
                                        defaultValue={whitelistIpText} ref={whitelistIpRef} />
                                    <label htmlFor="merchant_whitelist_ip_authenticator" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Authenticator
                                    </label>
                                    <input type={'text'} id="merchant_whitelist_ip_authenticator" className="form-control"
                                        name="merchant_whitelist_ip_authenticator" placeholder="Authenticator" ref={otpWhitelistRef} />
                                    <button className="btn btn-primary d-grid w-100 mt-1" type="button" onClick={updateWhitelistIp}>Update whitelist ip</button>
                                    <Divider sx={{ mt: 1 }} />
                                    <label htmlFor="callback_payin" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Callback payin
                                    </label>
                                    <input type={'text'} id="callback_payin" className="form-control"
                                        name="callback_payin" placeholder="Callback payin"
                                        defaultValue={dashboardData.callback_payin} ref={callbackPayinRef} />
                                    <label htmlFor="callback_payout" className="form-label"
                                        style={{ color: '#51659e' }}>
                                        Callback payout
                                    </label>
                                    <input type={'text'} id="callback_payout" className="form-control"
                                        name="callback_payout" placeholder="Callback payout"
                                        defaultValue={dashboardData.callback_payout} ref={callbackPayoutRef} />
                                    <button className="btn btn-primary d-grid w-100 mt-1" type="button" onClick={changeCallbackUrl}>Update callback</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null
            }
            
        </>
    )
}

export default Main;